import Conversion from './conversion'
import Bugsnag from '@bugsnag/js'

export default class extends Conversion {
  async install () {
    const appVersion = document.querySelector('meta[name=revision]')?.content
    Bugsnag.start({ apiKey: '5b408cd7bcf88f3ff69b4eaccd455382', appVersion })
    globalThis.Bugsnag = Bugsnag
  }

  push () {}
  defer () {}
  processDeferred () {}
}
